import * as React from "react";
const SvgBorjaom = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 42.5 42.5",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M39 28.1c-2.5 7.1-9.3 12.2-17.2 12.2-10.1 0-18.3-8.2-18.3-18.3S11.7 3.7 21.8 3.7c3.9 0 7.6 1.2 10.6 3.4l2.2-2.2c.3-.3.9-.2 1.1.3l1.3 5 1.3 5c.1.5-.3.9-.8.8l-5-1.3-4.9-1.3c-.5-.1-.6-.7-.3-1.1l2.4-2.4c-2.3-1.5-5.1-2.4-8-2.4C13.6 7.3 7 13.9 7 22s6.6 14.7 14.7 14.7c6 0 11.1-3.5 13.4-8.7H39z"
}));
export default SvgBorjaom;
